<template>
  <div class="sales-report__stats-box">
    <div class="css-grid sales-report__header">
      <div class="sales-report__header-name">Units Per Audiologist</div>
    </div>

    <div class="sales-report__body">
      <ChartCustom :chart-settings="chartConfig" :dimensions="chartConfig.size"></ChartCustom>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ChartCustom from '../../general/ChartCustom.vue';

  export default {
    name: 'StatsUnitsPerEmployee',
    components: {
      ChartCustom,
    },
    computed: {
      ...mapGetters('purchaseActivity', ['contents']),
      stats() {
        return this.contents.statsNational;
      },
      formattedData() {
        return {
          'category': ['Active'],
          'Practice': [this.stats.units_per_audiologist],
          'National Average': [this.stats.nat_units_per_audiologist]
        };
      },
      minValue() {
        var val1 = parseFloat(this.stats.units_per_audiologist);
        var val2 = parseFloat(this.stats.nat_units_per_audiologist);
        var percentResult = 0.92 * (val1 < val2 ? val1 : val2);
        return percentResult > 15 ? percentResult : undefined;
      },
      chartConfig() {
        return {
          size: {
            height: 140,
            //width: 818
          },
          // padding: {
          //   top: 20
          // },
          data: {
            json: this.formattedData,
            type: 'bar',
            x: 'category',
            labels: true,
            colors: {
              'Practice': '#824a9e',
              'National Average': '#39c2c9'
            },
          },
          axis: {
            x: {
              type: 'category',
              show: true,
              tick: {
                rotate: 90
              },
              height: 130
            },
            y: {
              show: false,
              min: this.minValue
            },
            rotated: true
          },
          bar: {
            space: 0.25,
            width: 50
          },
          legend: { show: true, position: 'bottom' },
          tooltip: {
            show: false
          }
        };
      },
    },
  };
</script>
